export default __webpack_public_path__ + "static/media/37.e06952a5.jpg";